export const keysThatUseClaimItemsInformation = [
  'patientInformation',
  'providerInformation',
  'dentalTreatment',
  'serviceDetails',
];
